// src/pages/data-deletion.jsx

import React from "react";
import "./LegalPages.css";

export default function DataDeletion() {
  const supportEmail = "support@nexterzone.com";

  return (
    <main className="legal-page">
      <section className="legal-hero">
        <h1>NexterZone User Data Deletion Instructions</h1>

        <p>
          This page explains how users who sign in to NexterZone using Facebook
          can request deletion of their account data.
        </p>

        <div className="legal-hero-links">
          <a href={`mailto:${supportEmail}?subject=NexterZone Account Data Deletion Request`}>
            Request data deletion
          </a>
          <a href="https://nexterzone.com" target="_blank" rel="noreferrer">
            Visit NexterZone
          </a>
        </div>
      </section>

      <section className="legal-grid">
        <article className="legal-card">
          <h2>How to request deletion</h2>

          <p>
            If you signed in to NexterZone using Facebook and would like your
            account data deleted, please send an email to:
          </p>

          <p>
            <strong>
              <a href={`mailto:${supportEmail}`}>{supportEmail}</a>
            </strong>
          </p>

          <p>Please include the following details in your request:</p>

          <ul>
            <li>The email address linked to your NexterZone account.</li>
            <li>Your full name, if available on your NexterZone profile.</li>
            <li>A clear statement requesting deletion of your account data.</li>
          </ul>
        </article>

        <article className="legal-card">
          <h2>What happens after we receive your request</h2>

          <p>
            Once we receive your request, we will verify that the email address
            is linked to a NexterZone account and process the deletion or
            anonymisation of your personal account data.
          </p>

          <ul>
            <li>We will confirm receipt of your request by email.</li>
            <li>We may request additional verification where necessary.</li>
            <li>
              Once verified, your account data will be deleted or anonymised
              where deletion is not technically or legally required.
            </li>
          </ul>
        </article>

        <article className="legal-card">
          <h2>Data that may be deleted</h2>

          <p>
            Depending on your account activity, the data associated with your
            NexterZone account may include:
          </p>

          <ul>
            <li>Account profile information.</li>
            <li>Facebook sign-in identifier linked to your account.</li>
            <li>Contact details associated with your NexterZone profile.</li>
            <li>Marketplace activity linked to your user account.</li>
          </ul>
        </article>

        <article className="legal-card">
          <h2>Data we may need to retain</h2>

          <p>
            Some records may need to be retained where required for legal,
            security, fraud-prevention, dispute-resolution, payment,
            accounting, or regulatory reasons.
          </p>

          <p>
            Where full deletion is not possible, NexterZone will take reasonable
            steps to anonymise or restrict the relevant data.
          </p>
        </article>
      </section>

      <section className="legal-callout">
        <h3>Contact details</h3>

        <p>
          Email:{" "}
          <strong>
            <a href={`mailto:${supportEmail}`}>{supportEmail}</a>
          </strong>
        </p>

        <p>
          Website:{" "}
          <strong>
            <a href="https://nexterzone.com" target="_blank" rel="noreferrer">
              https://nexterzone.com
            </a>
          </strong>
        </p>
      </section>

      <p className="legal-footnote">
        Last updated: May 2026. This page is provided for NexterZone users and
        for Facebook / Meta app data deletion compliance purposes.
      </p>
    </main>
  );
}